const config = {
    debug: true,
	web_title: "A3 Mall",
    base_url: window.location.protocol + "//" + window.location.host + "/homeapi",
    request_timeout: 60000,
    version: "3.3.2"
}

if(process.env.NODE_ENV == "development"){
    config.base_url = 'http://b2b2cv3-pro.top:8888/homeapi';
}

export default config